import React from "react";

import { QuestionCircleOutlined } from "@ant-design/icons";
import { Icon } from "@iconify/react";
import { Button, Popconfirm, Space, Tooltip } from "antd";

import { TenantPerson } from "js/components/types";

import { useDeleteTenant } from "../../../hooks/useDeleteTenant";
import { toast } from "../../../utils/toast";

interface ActionSelect {
  tenant: TenantPerson;
  data: TenantPerson[];
  setData: (data: TenantPerson[]) => void;
  onEdit?: (tenant: TenantPerson) => void;
}

const TenantActionSelect: React.FC<ActionSelect> = ({
  tenant,
  data,
  setData,
  onEdit,
}) => {
  const deleteTenantMutation = useDeleteTenant();

  const handleDeleteTenant = (tenantId: any) => {
    deleteTenantMutation.mutate(tenantId, {
      onSuccess: () => {
        toast.success("Inquilino eliminado exitosamente");
      },
      onError: (error: any) => {
        toast.error(
          error?.response?.data?.message || "Error al eliminar inquilino",
        );
      },
    });
  };

  return (
    <Space wrap>
      <Tooltip title="Editar">
        <Button
          size={"small"}
          type={"link"}
          onClick={() => onEdit && onEdit(tenant)}
        >
          <Icon fontSize={20} icon="akar-icons:edit" />
        </Button>
      </Tooltip>
      <Tooltip title="Eliminar">
        <Popconfirm
          title="Eliminar Inquilino"
          description="¿Seguro que deseas eliminar?"
          onConfirm={() => handleDeleteTenant(tenant.id)}
          icon={
            <QuestionCircleOutlined style={{ color: "red" }} rev={undefined} />
          }
          okText={"Ok"}
          cancelText={"Cancelar"}
        >
          <Button
            danger
            size={"small"}
            type={"link"}
            loading={deleteTenantMutation.isPending}
          >
            <Icon fontSize={20} icon="bi:trash3" />
          </Button>
        </Popconfirm>
      </Tooltip>
    </Space>
  );
};
export default TenantActionSelect;
